import PropTypes from "prop-types";
import React, { useState, useEffect, memo } from "react";
import { useGetCouponsByID } from "../../../queryHooks/useCoupons";

//	Component starts
const RestaurantList = ({ coupon, onCloseModal, refetch }) => {
	const [restaurantList, setRestaurantList] = useState([]);
	const { data: dataCouponById, isLoading } = useGetCouponsByID(coupon.id, {
		enabled: !!coupon.id,
	});

	useEffect(() => {
		if (dataCouponById) {
			setRestaurantList(dataCouponById?.data?.restaurants);
		}
	}, [dataCouponById]);

	return (
		<div className="modal-dialog modal-dialog-scrollable m-0 w-100">
			<div className="modal-content">
				<div className="modal-header">
					<h5 className="modal-title">Restaurant List</h5>
				</div>
				<div className="notification-form modal-body card profile-card password-modal">
					{isLoading ? (
						<p>Loading...</p>
					) : (
						<div className="row">
							{restaurantList?.length > 0
								? restaurantList.map((item, index) => {
										return (
											<div className="col-md-12" key={index}>
												<ul>
													<li>
														{" "}
														<h5>
															{index + 1}. {item.name}{" "}
														</h5>{" "}
													</li>
												</ul>
											</div>
										);
								  })
								: ""}
						</div>
					)}
				</div>
			</div>
		</div>
	);
};

/******************************************************************************************
@Purpose    :   To validate the props
*******************************************************************************************/
PropTypes.propTypes = {
	restaurantList: PropTypes.object,
	columnKey: PropTypes.string.isRequired,
	onCloseModal: PropTypes.func.isRequired,
};

export default memo(RestaurantList);
